import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/cart';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const createCartItem = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/create-cart-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const checkCartItem = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/check-cart-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const checkCartType = async (typeData) => {
  try {
    const response = await axios({
      url: `${API_URL}/check-cart-type`,
      method: 'POST',
      data: typeData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createPackageCartItem = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/package/create-cart-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const addWishlistPackageToCart = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/wishlist/package/create-cart-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createCustomizationItem = async (itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/customization/create-cart-item`,
      method: 'POST',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getAllCartItems = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-cart-items`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getItemDetails = async (item_id, item_type) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-item-details`,
      method: 'GET',
      params: {
        item_id,
        item_type,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getAllFoodCartItems = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-food-cart-items`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getAddOnItems = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-add-on-items`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getCartItemById = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-cart-item/${id}`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateCartItem = async (id, itemData) => {
  try {
    const response = await axios({
      url: `${API_URL}/update-cart-item/${id}`,
      method: 'PUT',
      data: itemData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteCartItem = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/delete-cart-item/${id}`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const clearCart = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/clear-cart`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const clearPackageFromCart = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/clear-cart-package`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const clearVenueFromCart = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/clear-cart-venue`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getCartSummary = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/cart-summary`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const cartService = {
  createCartItem,
  checkCartItem,
  checkCartType,
  createPackageCartItem,
  addWishlistPackageToCart,
  createCustomizationItem,
  getAllCartItems,
  getItemDetails,
  getAllFoodCartItems,
  getCartItemById,
  updateCartItem,
  deleteCartItem,
  clearCart,
  getAddOnItems,
  getCartSummary,
};

export default cartService;
